export const ActionName = {
  Delete: 'delete',
  AddToFavourites: 'add-to-favourites',
  RemoveFromFavourites: 'remove-from-favourites',
  ViewListing: 'view-listing',
  ViewSoldProperty: 'view-sold-property',
  ViewDashboard: 'view-dashboard',
  EditListing: 'edit-listing',
  ShareListing: 'share-listing',
  ApproveListing: 'approve-listing',
  EditIcon: 'edit',
  ReList: 're-list',
};
export const ActionTitle = {
  ApproveListing: 'Approve Listing',
  ViewListing: 'View Listing',
  ViewSoldDetails: 'View Details',
  ViewSoldProperty: 'View Property',
  ViewDashboard: 'View Dashboard',
  RequestInfo: 'Request More Info',
  EditListing: 'Edit Listing',
  ReList: 'Re-list Now',
};
export const ListingCardPropsEventType = {
  Delete: 'delete',
  ToggleFavourites: 'toggle-favourite',
};

export default {
  ActionName,
  ActionTitle,
  ListingCardPropsEventType,
};
